import validate from "/opt/app-root/src/website/node_modules/nuxt/dist/pages/runtime/validate.js";
import trailing_45slash_45global from "/opt/app-root/src/website/middleware/trailing-slash.global.ts";
import manifest_45route_45rule from "/opt/app-root/src/website/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/app-root/src/website/middleware/auth.ts")
}